import Model, { hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkSecurityDepositSettingModel extends Model {
  @hasMany('security-deposit-setting', { inverse: null, async: false })
  securityDepositSettings!: ModelRegistry['security-deposit-setting'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-security-deposit-setting': BulkSecurityDepositSettingModel;
  }
}
